import { render, staticRenderFns } from "./LayoutWrapper.vue?vue&type=template&id=1d3fe258&"
import script from "./LayoutWrapper.vue?vue&type=script&lang=ts&"
export * from "./LayoutWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports